import { useQuery } from '@tanstack/react-query';

import {
  type Pharmacy,
  mapPharmacyDTOToPharmacy,
} from '~entities/pharmacy/@x/session';

import { sessionQueries } from './queries';
import { PropsResponse } from './types';

interface Session extends Omit<PropsResponse, 'pharmacy'> {
  pharmacy: Pharmacy;
}

export const useSession = (pharmacyId: string | undefined) => {
  const {
    data: session,
    isPending,
    isError,
  } = useQuery({
    ...sessionQueries.detail(pharmacyId),
    select: (data): Session => ({
      ...data,
      pharmacy: mapPharmacyDTOToPharmacy(data.pharmacy),
    }),
  });

  return { session, isPending, isError };
};
